import React from 'react';
import PropTypes from 'prop-types';
import { Button, Form } from 'react-bootstrap';
import ReactGA from 'react-ga';

import './signUp.scss';
import CONFIG from '../../../config/config';
import FormTitleComponent from '../../../components/core/FormTitleComponent/FormTitleComponent';
import CompanyFormFieldsLayout from '../../../layouts/Company/CompanyForm/CompanyFormFieldsLayout';
import SignUpFormCheckboxLayout from '../../../layouts/SignUp/SignUpFormCheckboxLayout';
import FieldGroupComponent from '../../core/FieldGroupComponent/FieldGroupComponent';

const { siteKey } = CONFIG.captcha;

class SignUpCompanyComponent extends React.Component {
    handleSubmit = () => {
        ReactGA.event({
            category: 'Sign Up Company Component',
            action: 'Clicked Create Account',
            label: 'Button',
        });
    }

    render() {
        const { otherFields, handleSubmit, prevPage, invalid } = this.props;

        return <div>
            <div className="back-option" onClick={prevPage}>
                <span> Back </span>
            </div>
            <Form onSubmit={handleSubmit}>
                <FormTitleComponent title="Company Information" />
                <CompanyFormFieldsLayout otherFields={otherFields} />
                {siteKey && <FieldGroupComponent
                    name="captcha"
                    type="captcha"
                />}
                <SignUpFormCheckboxLayout />
                <div className="buttons">
                    <Button disabled={invalid} type="submit" onClick={this.handleSubmit} className="next">Create Account</Button>
                </div>
            </Form>
        </div>
    }
}

SignUpCompanyComponent.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    otherFields: PropTypes.object.isRequired,
    prevPage: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
};

export default SignUpCompanyComponent;



// WEBPACK FOOTER //
// ./src/components/login/SignUp/SignUpCompanyComponent.js